import React, {
  useContext
} from 'react';
import {
  Route, withRouter
} from 'react-router-dom';
import {
  SessionsKeys
} from 'src/Common/constants';
import Breadcrumb from 'src/Components/Breadcrumbs/Breadcrumb';
import LocationConfirmation from 'src/Components/LocationConfirmation/LocationConfirmation';
import NewCustomerRouteWrapper from 'src/Components/NewCustomerRouteWrapper/NewCustomerRouteWrapper';
import {
  SalesContext
} from 'src/Context/SalesContext';

const NavLayoutRouteWrapper = ({ component: Component, avoidHeaders = false, ...rest }) => {

  const context = useContext(SalesContext);

  const pathComponents = rest.location.pathname.toUpperCase().split('/');
  const currentPath = pathComponents[pathComponents.length - 1];
  const appProactiveSales = sessionStorage.getItem(SessionsKeys.ProactiveSalesFlag);
  const appProactiveSalesFlag = !!(appProactiveSales && appProactiveSales.toUpperCase() === 'TRUE');

  if (currentPath === 'LEADS') {

    window.location.href = '/vodacom/fibre/sales/leads';
  }

  if (!validateRoute(currentPath, context)) {

    if (currentPath !== 'SUCCESS' && currentPath !== 'CONFIRMATION') {

      rest.history.push('/cloud/fibre/sales/order');

      return null;
    }
  }

  if (avoidHeaders) {

    return (

      <Route
        {...rest}
        render={(props) => <Component {...props} /> } />
    );
  }

  const currentProgress = getCurrentProgress(currentPath);

  // TODO: Add a type property to route configs to avoid listing paths.
  if (
    currentPath === 'DOCUMENT-NOTES'
    || currentPath === 'UPLOAD-DOCUMENTS'
    || currentPath === 'CREDIT-VETTING'
    || currentPath === 'REVIEW-ORDER'
    || currentPath === 'CONFIRMATION'
    || currentPath === 'SUCCESS'

  ) {

    return (

      <Route {...rest}
        render={(props) =>
          <NewCustomerRouteWrapper
            component={Component}
            {...props} />
        } />
    );
  } else if (
    currentPath !== 'CHOOSEPLAN'
    && currentPath !== 'PLANDETAILS'
    && currentPath !== 'TRACKSALESORDER'
    && currentPath !== 'ORDER'
    && currentPath !== 'DELIVERYADDRESS'
    && currentPath !== 'FIBRE-DEALS'
    && currentPath !== 'LOG-IN'
    && currentPath !== 'CUSTOMERAPPROVAL'
    && currentPath !== 'CUSTOMERAPPROVALNEWCUSTOMER'
    && currentPath !== 'LEADCONFIRMATION'
    || currentPath === 'CONFIRMATION'
  ) {

    return (

      <Route
        {...rest}
        render={(props) =>
          <>
            <Breadcrumb
              currentPath={currentPath}
              currentPathTitle={currentProgress.breadCrumbTitle} />

            { (currentPath === 'CHOOSEPLAN' || currentPath === 'ORDER') && appProactiveSalesFlag

              ? <LocationConfirmation />
              : null
            }

            <Component {...props} />
          </>
        } />
    );
  } else {

    return (

      <Route
        {...rest}
        render={(props) =>
          <React.Fragment>
            <Component {...props} />
          </React.Fragment>
        } />
    );
  }
};

export default withRouter(NavLayoutRouteWrapper);

const getCurrentProgress = currentPath => {

  switch (currentPath) {

  case '':
  case 'CHOOSEPLAN':
  case 'ORDER':
    return { progress: '25%', step: 1, title: 'Fibre plan', breadCrumbTitle: 'Choose a fibre plan', totalSteps: 4 };
  case 'PLANDETAILS':
    return { progress: '50%', step: 2, title: 'Plan details', breadCrumbTitle: 'Plan details', totalSteps: 4 };
  case 'VUMATELPLANDETAILS':
    return { progress: '25%', step: 1, title: 'Plan details', breadCrumbTitle: 'Plan details', totalSteps: 3 };
  case 'DELIVERYADDRESS':
    return { progress: '75%', step: 3, title: 'Address', breadCrumbTitle: 'Confirm delivery address', totalSteps: 4 };
  case 'EMPLOYERDETAILS':
    return { progress: '75%', step: 3, title: 'Address', breadCrumbTitle: 'Employment details', totalSteps: 4 };
  case 'VUMACONTACTINFORMATION':
    return { progress: '75%', step: 2, title: 'Contact', breadCrumbTitle: 'Get in touch', totalSteps: 3 };
  case 'CONTACTINFORMATION':
    return { progress: '100%', step: 4, title: 'Contact Information', breadCrumbTitle: 'Contact information', totalSteps: 4 };
  case 'QUOTATION':
    return { progress: '100%', step: 4, title: 'Quotation', breadCrumbTitle: 'Quotation', totalSteps: 4 };
  default:
    return { progress: '25%', step: 1, title: 'Fibre plan', breadCrumbTitle: '', totalSteps: 4 };
  }
};

const validateRoute = (path, context) => {

  switch (path) {

  case 'PLANDETAILS':
  case 'DELIVERYADDRESS':
  case 'CONTACTINFORMATION':
  case 'EMPLOYERDETAILS':
  case 'QUOTATION':
  case 'DOCUMENT-NOTES':
  case 'CREDIT-VETTING':
  case 'UPLOAD-DOCUMENTS':
  case 'REVIEW-ORDER':
    return context?.plans?.length > 0 ? true : false;
  case 'SUCCESS':
  case 'CONFIRMATION':
    return (context.userDetails && (context.userDetails.referenceNo || context.userDetails.quoteNumber)) ? true : false;
  default:
    return true;
  }
};
